import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';

type FormWrapperProps = {
    title: string;
    children: ReactNode;
    text?: string;
};

export function EsFormWrapper({ title, children, text }: FormWrapperProps) {
    const { themeStyle } = useThemeContext();

    return (
        <Box>
            <Typography
                variant="h2"
                style={{
                    maxWidth: 400,
                    width: '100%',
                    textAlign: 'left',
                    fontSize: 20,
                    fontStyle: 'normal',
                    fontWeight: '600',
                    lineHeight: '32px',
                    marginBottom: '10px',
                    marginTop: '8px',
                    color: theme[themeStyle].tag_white,
                    fontFamily: FONT_ENUM.MAIN_BOLD,
                }}>
                {title}
            </Typography>
            <Typography
                style={{
                    maxWidth: 400,
                    width: '100%',
                    textAlign: 'left',
                    fontSize: 14,
                    fontStyle: 'normal',
                    fontWeight: '500',
                    color: theme[themeStyle].tag_white,
                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                }}>
                {text}
            </Typography>
            {children}
        </Box>
    );
}
